import { render, staticRenderFns } from "./4mImpr.vue?vue&type=template&id=cb769004"
import script from "./4mImpr.vue?vue&type=script&lang=js"
export * from "./4mImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb769004')) {
      api.createRecord('cb769004', component.options)
    } else {
      api.reload('cb769004', component.options)
    }
    module.hot.accept("./4mImpr.vue?vue&type=template&id=cb769004", function () {
      api.rerender('cb769004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/risk/4mImpr.vue"
export default component.exports